export const Roles = {
   SUPERADMIN: "SUPERADMIN",
   ADMIN: "ADMIN",
};

export const ACLSubject = {
   USER: "user",
   REQUEST: "request",
   INPUT_TRACK: "input_track",
   OUTPUT_TRACK: "output_track",
   INCOME_REQUEST: "income_request",
   INCOME_INPUT_TRACK: "income_input_track",
   INCOME_OUTPUT_TRACK: "income_output_track",
   API_SETTING: "api_setting",
};

export const RequestStatusType = {
   UPLOADED: "UPLOADED",
   VALIDATING: "VALIDATING",
   VALIDATED: "VALIDATED",
   VALIDATION_ERROR: "VALIDATION_ERROR",
   INPUT_GENERATION_QUEUE: "INPUT_GENERATION_QUEUE",
   INPUT_GENERATION: "INPUT_GENERATION",
};

export const InputTrackStatusType = {
   INPUT_GENERATED: "INPUT_GENERATED",
   OUTPUT_IMPORT_QUEUE: "OUTPUT_IMPORT_QUEUE",
   OUTPUT_IMPORTING: "OUTPUT_IMPORTING",
   OUTPUT_IMPORTED: "OUTPUT_IMPORTED",
   OUTPUT_IMPORT_ERROR: "OUTPUT_IMPORT_ERROR",
   OUTPUT_DELETING_RECORD: "OUTPUT_DELETING_RECORD",
   OUTPUT_DELETING_RECORD_ERROR: "OUTPUT_DELETING_RECORD_ERROR",
};

export const RegistryKeyType = {
   PHYSICAL: "PHYSICAL",
   COMPANY: "COMPANY",
};

export const IncomeRequestStatusType = {
   UPLOADED: "UPLOADED",
   VALIDATING: "VALIDATING",
   VALIDATED: "VALIDATED",
   VALIDATION_ERROR: "VALIDATION_ERROR",
   INPUT_GENERATION_QUEUE: "INPUT_GENERATION_QUEUE",
   INPUT_GENERATION: "INPUT_GENERATION",
};

export const IncomeInputTrackStatusType = {
   INPUT_GENERATED: "INPUT_GENERATED",
   OUTPUT_IMPORT_QUEUE: "OUTPUT_IMPORT_QUEUE",
   OUTPUT_IMPORTING: "OUTPUT_IMPORTING",
   OUTPUT_IMPORTED: "OUTPUT_IMPORTED",
   OUTPUT_IMPORT_ERROR: "OUTPUT_IMPORT_ERROR",
   OUTPUT_DELETING_RECORD: "OUTPUT_DELETING_RECORD",
   OUTPUT_DELETING_RECORD_ERROR: "OUTPUT_DELETING_RECORD_ERROR",
};

export const IncomePositionType = {
   ND: "ND",
   DIPENDENTE_DETERMINATO: "DIPENDENTE_DETERMINATO",
   DIPENDENTE_INDETERMINATO: "DIPENDENTE_INDETERMINATO",
   PENSIONE: "PENSIONE",
};

export const IncomeRequestProcessEsitoTypes = {
   ESITO_A: "ESITO_A",
   ESITO_A_HORIZONTAL: "ESITO_A_HORIZONTAL",
   ESITO_B: "ESITO_B",
   ESITO_B_HORIZONTAL: "ESITO_B_HORIZONTAL",
};

export const IncomeRequestAnalysisTagsTypes = {
   PENSIONATO: "PENSIONATO",
   DECEDUTO: "DECEDUTO",
   INOCCUPATO_3_ANNI_STRANIERO: "INOCCUPATO_3_ANNI_STRANIERO",
};
